import { render, staticRenderFns } from "./AdminHospitalBookingList.vue?vue&type=template&id=122c477f&scoped=true"
import script from "./AdminHospitalBookingList.vue?vue&type=script&lang=js"
export * from "./AdminHospitalBookingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122c477f",
  null
  
)

export default component.exports